import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { Link } from "react-router-dom";



const ProcessingPayment = () => {
  const translation = getTranslationData();
  
  return (
    <><div className="payment-processing-container">
      <div className="d-flex flex-column justify-content-center align-items-center text-center process-payment">
        {/* <img src={processingPaymentImg} className="responsive-image"></img> */}
        <svg className="payment-failed-icon client1-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="68"
          height="67"
          viewBox="0 0 68 67"
          fill="none"
        >
          <path
            d="M65.3207 66.6536H3.65405C2.28739 66.6536 1.15405 65.5203 1.15405 64.1536C1.15405 62.787 2.28739 61.6536 3.65405 61.6536H65.3207C66.6874 61.6536 67.8207 62.787 67.8207 64.1536C67.8207 65.5203 66.6874 66.6536 65.3207 66.6536Z"
            fill="currentColor"
          />
          <path
            opacity="0.4"
            d="M63.1203 38.986L39.0203 63.086C34.287 67.8193 26.6536 67.8193 21.9536 63.1193L6.58691 47.7526L47.787 6.55273L63.1537 21.9194C67.8537 26.6194 67.8536 34.2526 63.1203 38.986Z"
            fill="currentColor"
          />
          <path
            d="M47.7876 6.55418L6.55418 47.7543L3.52084 44.721C-1.17916 40.021 -1.17916 32.3876 3.55418 27.6543L27.6542 3.55418C32.3876 -1.17916 40.021 -1.17916 44.721 3.52084L47.7876 6.55418Z"
            fill="currentColor"
          />
          <path
            d="M37.4534 51.9866L32.9534 56.4866C32.02 57.4199 30.5201 57.4199 29.5867 56.4866C28.6534 55.5533 28.6534 54.0533 29.5867 53.1199L34.0867 48.6199C35.0201 47.6866 36.5201 47.6866 37.4534 48.6199C38.3867 49.5533 38.3867 51.0533 37.4534 51.9866Z"
            fill="currentColor"
          />
          <path
            d="M52.0536 37.387L43.0869 46.3536C42.1536 47.287 40.6536 47.287 39.7203 46.3536C38.7869 45.4203 38.7869 43.9203 39.7203 42.987L48.6869 34.0203C49.6203 33.087 51.1203 33.087 52.0536 34.0203C52.9536 34.9536 52.9536 36.4536 52.0536 37.387Z"
            fill="currentColor"
          />
        </svg>
        <svg className="processing-icon-firstRewardGallary" xmlns="http://www.w3.org/2000/svg" width="81" height="81" viewBox="0 0 81 81" fill="none">
          <g clip-path="url(#clip0_5250_23521)">
            <rect width="81.0001" height="81.0001" fill="white" />
            <g opacity="0.8" filter="url(#filter0_d_5250_23521)">
              <path d="M10.0963 31.8503C10.0963 30.6348 10.0963 30.0271 10.3699 29.5806C10.523 29.3308 10.7331 29.1208 10.9829 28.9677C11.4293 28.6941 12.0371 28.6941 13.2526 28.6941H64.2038C65.4193 28.6941 66.027 28.6941 66.4735 28.9677C66.7233 29.1208 66.9333 29.3308 67.0864 29.5806C67.36 30.0271 67.36 30.6348 67.36 31.8503V55.2852C67.36 56.5007 67.36 57.1085 67.0864 57.5549C66.9333 57.8047 66.7233 58.0148 66.4735 58.1679C66.027 58.4415 65.4193 58.4415 64.2038 58.4415H13.2526C12.0371 58.4415 11.4293 58.4415 10.9829 58.1679C10.7331 58.0148 10.523 57.8047 10.3699 57.5549C10.0963 57.1085 10.0963 56.5007 10.0963 55.2852V31.8503Z" fill="#EEF4FD" />
            </g>
            <g opacity="0.8">
              <rect x="4.6906" y="23.3005" width="57.2637" height="29.7474" rx="1.85662" fill="#A6BFF5" />
            </g>
            <g clip-path="url(#clip1_5250_23521)">
              <rect x="5.72205e-05" y="17.3757" width="57.2637" height="29.7474" rx="1.85662" fill="#5971F6" />
              <rect x="-0.650528" y="16.9236" width="58.3406" height="6.65288" fill="#809AF4" />
            </g>
            <rect x="5.85471" y="27.1592" width="25.7557" height="2.5588" rx="1.2794" fill="#809AF4" />
            <rect x="5.85471" y="32.7881" width="45.4512" height="2.5588" rx="1.2794" fill="#809AF4" />
          </g>
          <defs>
            <filter id="filter0_d_5250_23521" x="7.19097" y="26.8122" width="72.2861" height="44.7698" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
              <feOffset dx="4.60585" dy="5.62937" />
              <feGaussianBlur stdDeviation="3.75561" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0 0.313726 0 0 0 0.2 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5250_23521" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5250_23521" result="shape" />
            </filter>
            <clipPath id="clip0_5250_23521">
              <rect width="81.0001" height="81.0001" fill="white" />
            </clipPath>
            <clipPath id="clip1_5250_23521">
              <rect x="5.72205e-05" y="17.3757" width="57.2637" height="29.7474" rx="1.85662" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <div className="payment-processing-heading">
          {translation?.processing_payment_heade_msg}
        </div>
        <p className="payment-processing-message">
          {translation?.processing_payment_description_msg_1}
        </p>
        <p className="payment-processing-message mb-0">
          {translation?.processing_payment_description_msg_2}
        </p>
        <div className="payment-processing-color-label">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#DA3442"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12" y2="8" />
          </svg>

          <span className="warning-txt">{translation.payment_processing_color_label}</span>
        </div>
        <div className="continue-shopping-containerbox">
          <Link className="continue-shopping-btn" to={"/productlist"}>
            {translation?.continue_shopping}
          </Link>
          <Link className="view-order-btn" to={"/orders"}>
            <span>{translation?.view_orders}</span>
          </Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default ProcessingPayment;
